<div class="drawing-controls-container">
  <div [title]="''" class="map-control-btn" [ngClass]="{ 'mobile-btn': isMobile}" (click)="onCancelDrawClick()">
    <i class="material-symbols-outlined my-location-icon" [ngClass]="{'selected' : drawingState === false}">pan_tool</i>
  </div>
  <div class="divider" *ngIf="!isMobile"></div>
  <div [title]="''" class="map-control-btn" [ngClass]="{ 'mobile-btn': isMobile}" (click)="onDrawClick()">
    <i class="material-symbols-outlined my-location-icon" [ngClass]="{'selected' : drawingState === true}">stylus</i>
  </div>
</div>
